export type Path =
  | '/home'
  | '/'
  | '/especialidades'
  | '/error'
  | '/miagenda'
  | '/agendar'
  | '/agendarconsulta'
  | '/provisory-pip'
  | '/especialidades/:specialtyId'
  | '/associatedProducts'
	| '/associateProduct'
	| '/assignAnotherCard'
	| '/processRemoveProduct'
	| '/processChangingProducts'
	// PAGE PATHS TYPE DECLARATIONS

export const PATHS: Record<string, Path> = {
  HOME: '/home',
  ROOT: '/',
  SPECIALTIES: '/especialidades',
  ERROR: '/error',
  BOOKING: '/agendarconsulta',
  PROVISORY_PIP: '/provisory-pip',
  APPOINTMENT_SCHEDULER: '/agendar',
  SPECIALTY_DETAIL: '/especialidades/:specialtyId',
  MYDIARY: '/miagenda',
  ASSOCIATEDPRODUCTS: '/associatedProducts',
	ASSOCIATEPRODUCT: '/associateProduct',
	ASSIGN_ANOTHER_CARD: '/assignAnotherCard',
	PROCESS_REMOVE_PRODUCT: '/processRemoveProduct',
	PROCESS_CHANGING_PRODUCTS: '/processChangingProducts',
	// PAGE PATHS DECLARATIONS
}
